import React, { useEffect } from "react";
import "../css/homePage.css";
import HeroSection from "../components/HeroSection";
import { Helmet } from "react-helmet-async";
import MarqueeAnimationSection from "../components/MarqueeAnimationSection";
import FigpassSection from "../components/FigpassSection";
import AboutSection from "../components/AboutSection";
import StickyPhoneSection from "../components/StickyPhoneSection";
import FeaturesSection from "../components/FeaturesSection";
import TestimonialSection from "../components/TestimonialSection";
import Footer from "../components/Footer";
import { GamePlayMedia, SimulatorMedia } from "../common/json/sticky-phone-section";
import { FeatureFigs, Features } from "../common/json/features";
import { Testimonials } from "../common/json/testimonials";
import { Figpasses, FigpassGem } from "../common/json/figpasses";

const Home = () => {  
  const totalGems = 84554;

  useEffect(() => {
    document.title = "Figrun – Discover, Play, and Win Real Prizes";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Figrun – Discover, Play, and Win Real Prizes! Join the world’s first social discovery app that rewards you for exploring both virtual and real-world locations. Unlock Figs, collect Gems, and win cash rewards while connecting with friends and brands. Start your adventure today!"
      );
  }, []);

  return (
    <>
      <Helmet>
        <title>Figrun – Discover, Play, and Win Real Prizes</title>
      </Helmet>
      <HeroSection totalGems={totalGems} />
      <MarqueeAnimationSection />
      <FigpassSection figPlan={Figpasses} gem={FigpassGem} />
      <AboutSection />
      <StickyPhoneSection
        simulatorMedia={SimulatorMedia}
        gamePlayMedia={GamePlayMedia}
      />
      <FeaturesSection community={Features} data={FeatureFigs} />
      <TestimonialSection feedbackData={Testimonials} />
      <Footer />
    </>
  );
};

export default Home;
